import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../../components/cargando";
import SinPermisos from "./../../components/sinpermisos";
import Nav from "react-bootstrap/Nav";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const url = "https://api.dacapo.com.ve/public/vistamensajes";

const Historialchat = () => {
  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  //////////////Iniciando Status data//////////////////////////
  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(url);
      setData(response.data);
      setPending(false);
    };
    fetchData();
  }, []);

  const handleShowModal = (message) => {
    setSelectedMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMessage("");
  };

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      width: "50px",
    },
    {
      name: "Clase",
      selector: (row) => row.Clase,
    
    },
    {
      name: "Nombre",
      selector: (row) => row.nombreAlumno,
    
    },
    {
      name: "Profesor",
      selector: (row) => row.nombreProfesor,
      
    },
    {
      name: "Mensajes",
      cell: (row) => (
        <Button variant="link" onClick={() => handleShowModal(row.mensajes)}>
          <FaIcons.FaEye />
        </Button>
      ),
      
    },
    {
      name: "Fecha",
      selector: (row) => row.fecha,
   
    },
  ];

  /////////////Buscar datos//////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      if (resultdata.mensajes.toLowerCase().match(buscar.toLowerCase())) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  /////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "admin") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-2">Historial Chat</div>
                    <div className="col-md-10 text-left"></div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title>Historial Chat registrados</Card.Title>
                  <p>Historial registrados en el sistema.</p>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="No hay elementos a mostrar"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />
                </Card.Body>
              </Card>
            </Sidebar>
          </div>

          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Mensaje</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ whiteSpace: "pre-wrap", overflowY: "auto", maxHeight: "400px" }}>
              {selectedMessage.split("|").join("\n")}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Cerrar
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Historialchat;